import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Form, Input, Row } from "antd";
import moment from "moment";

import partnersApi from "../../../apis/Partners.api";
import GroupBuyingEvent from "../../../pages/channel/GroupBuyingEvent";

import HomeNotice from "./HomeNotice";
import QuickMenuList from "./QuickMenuList";

const HomeBanner = ({ isMobile }) => {
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	// const influencerId = reduxChannel?.influencer_id;

	const [eventShow, setEventShow] = useState(false);

	const [mediaResult, setMediaResult] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	useEffect(() => {
		getTime();
	}, []);

	const getTime = async () => {
		const res = await partnersApi.getServerTime();
		if (res.code === 200) {
			const endDate = moment("2023-07-18 17:00");
			// const endDate = moment("2023-06-27 11:12");
			const serverTime = moment(res.result);
			// console.log(moment(res.result).format("YYYY.MM.DD a h:mm:ss"));
			if (endDate.diff(serverTime) > 0) {
				setEventShow(true);
			} else {
				setEventShow(false);
			}
		} else {
			setEventShow(false);
		}
	};
	return (
		<>
			{/*{influencerId === "mediman" ? (*/}
			{/*{influencerId !== "squidtv" ? (*/}
			{reduxChannel?.influencer_id !== 9 ? (
				<div
					// className={`home-header ${influencerId === "mediman" ? "" : "home-header-default"}`}
					className={`home-header home-header-default`}
					style={
						reduxChannel?.color_1
							? { backgroundColor: reduxChannel?.color_1 }
							: { backgroundColor: "#272847" }
					}
				>
					<>
						<div className={`home-title-div`} style={{ alignItems: "center" }}>
							{reduxChannel?.user_id === 7 ? (
								<>
									<h1 className={`home-title`} style={{ textAlign: "center" }}>
										"어떤 영양제가 좋을까?"
									</h1>
									<p
										style={{
											whiteSpace: "pre-wrap",
											fontWeight: "bold",
										}}
									>
										{reduxChannel?.nickname ?? "채널명"}에서{"\n"}소개한 제품을
										지금 바로 확인해보세요.
									</p>
								</>
							) : (
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										gap: "0.5em",
									}}
								>
									<h2
										className={`home-banner-content`}
										style={{ textAlign: "center" }}
									>
										{reduxChannel?.banner_content
											? reduxChannel?.banner_content
											: "어떤 영양제가 좋을까?"}
									</h2>
									<h1 className={`home-title`} style={{ textAlign: "center" }}>
										{reduxChannel.nickname}
									</h1>
								</div>
							)}
							<Form size={`large`}>
								<Input.Search
									className={`home-search-bar`}
									type={`text`}
									placeholder={`${
										isMobile
											? `검색 예시) ${
													reduxChannel?.placeholder
														? reduxChannel?.placeholder
														: "비타민"
											  }`
											: `증상, 영양제 검색하기 (예시: ${
													reduxChannel?.placeholder
														? reduxChannel?.placeholder
														: "비타민"
											  })`
									}`}
									allowClear
									size={`large`}
									onSearch={(value) => {
										if (value?.length > 0) {
											history.push(
												`/together/channel/search?query=${value}&id=${reduxChannel?.influencer_id}`
											);
										}
									}}
									enterButton="검색하기"
								/>
							</Form>
						</div>

						{/* 퀵 버튼 */}
						<QuickMenuList />
					</>
				</div>
			) : reduxChannel?.influencer_id ? (
				<div
					className={`home-recommend-horizontal home-channel-triple-each`}
					style={{
						width: "100%",
						padding: 0,
						backgroundColor: "inherit",
						gap: "1em",
					}}
				>
					{eventShow ? (
						<GroupBuyingEvent />
					) : (
						<div
							className={`${
								mediaResult && `max-width-apply`
							} group-buying-event`}
							// onClick={() => {
							//     if (reduxChannel?.user_id !== 7) {
							//         window.open("https://forms.gle/HcCteqeNfpxHnuLH7");
							//     }
							// }}
						>
							<div
								className={`group-buying-event-banner`}
								style={
									mediaResult
										? {
												backgroundColor: "#d8cdbb",
												borderRadius: 0,
												padding: "2.5em 2em",
										  }
										: {
												backgroundColor: "#d8cdbb",
												borderRadius: 0,
										  }
								}
							>
								<p
									className={"red-title"}
									id={`home-banner-font`}
									style={{ color: "#005da9" }}
								>
									이벤트 마감 및 당첨자 발표 안내
								</p>
								<p
									className={`black-title`}
									id={`home-banner-font`}
									style={{ color: "#212529" }}
								>
									참여해 주신 모든 갑오징어분들에게
								</p>
								<p
									className={`black-title`}
									id={`home-banner-font`}
									style={{ color: "#212529" }}
								>
									감사 인사드립니다!
								</p>
								<div
									className={`event-left-time`}
									style={{
										paddingTop: "0.5em",
									}}
								>
									<p style={{ color: "#212529" }}>
										당첨자 발표 : 2023년 7월 20일(목) 오후 1시
									</p>
								</div>
								<Row
									justify={"space-between"}
									style={{
										paddingTop: "2em",
									}}
								>
									{/*<Button style={{*/}
									{/*    backgroundColor: "inherit",*/}
									{/*    border: "solid 1px #212529",*/}
									{/*    borderRadius: "17px"*/}
									{/*}}>*/}
									{/*    이벤트 참여하기*/}
									{/*</Button>*/}
									<img
										// src={`/assets/images/channel/squid-banner-img.png`}
										src={`/assets/images/channel/event/squid-1950.png`}
										alt={`오징어 하우스 이벤트`}
										style={{
											width: "70%",
											height: "auto",
											cursor: "pointer",
											marginLeft: "auto",
										}}
									/>
								</Row>
							</div>
						</div>
					)}
					{!mediaResult && <HomeNotice />}
				</div>
			) : (
				<></>
			)}
		</>
	);
};
export default HomeBanner;
